import {checkIsFirefox} from "helpers"
import {useRef} from "react"

export const useKlassappTable = (delay = 0) => {
    const tableRef = useRef(null)
    const isFirefox = checkIsFirefox()

    const scrollToBottom = () => {
        setTimeout(() => {
            if (tableRef.current) {
                if (isFirefox) {
                    tableRef.current.scrollTop = tableRef.current.scrollHeight
                } else {
                    const container = tableRef.current._container
                    if (container) {
                        container.scrollTop = container.scrollHeight
                    }
                }
            }
        }, delay)
    }

    return {tableRef, scrollToBottom}
}
